import {get} from "lodash"
import BaseService from "./Base"
import {
    PivotPointAttendance,
    PivotPointAttendanceImportRun,
    PivotPointAttendanceImportRunListRequest,
    PivotPointAttendanceListRequest,
    PivotPointImportRun,
    PivotPointImportRunListRequest,
    PivotPointPaginatedResponse,
    PivotPointGrade,
    PivotPointGetGradeSourcePayloadRequest,
    PivotPointGetGradeSourcePayloadResponse,
    PivotPointGradeListRequest,
    PivotPointUpdateGradeRequest,
    PivotPointUpdateGradeResponse,
    PivotPointUserMapping,
    PivotPointUserMappingListRequest,
    PivotPointUpdateMappingRequest,
    PivotPointUpdateMappingResponse,
    PivotPointClient,
    PivotPointClientListRequest
} from "types/integrations/pivotPoint"

class PivotPointIntegrationService extends BaseService {
    async listClients(params: PivotPointClientListRequest): Promise<PivotPointPaginatedResponse<PivotPointClient>> {
        const response = await this.post("/v1/integrations/pivot-point/clients/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async listImportRuns(
        params: PivotPointImportRunListRequest
    ): Promise<PivotPointPaginatedResponse<PivotPointImportRun>> {
        const response = await this.post("/v1/integrations/pivot-point/import-runs/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async listAttendanceImportRuns(
        params: PivotPointAttendanceImportRunListRequest
    ): Promise<PivotPointPaginatedResponse<PivotPointAttendanceImportRun>> {
        const response = await this.post("/v1/integrations/pivot-point/attendance-import-runs/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async listUserMappings(
        params: PivotPointUserMappingListRequest
    ): Promise<PivotPointPaginatedResponse<PivotPointUserMapping>> {
        const response = await this.post("/v1/integrations/pivot-point/mappings/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async updateUserMapping(params: PivotPointUpdateMappingRequest): Promise<PivotPointUpdateMappingResponse> {
        const response = await this.post("/v1/integrations/pivot-point/mappings/update", params)
        return get(response, "data", {
            success: false,
            data: {id: params.mappingId, studentProfileId: params.studentProfileId}
        })
    }

    async listGrades(params: PivotPointGradeListRequest): Promise<PivotPointPaginatedResponse<PivotPointGrade>> {
        const response = await this.post("/v1/integrations/pivot-point/grades/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async listAttendance(
        params: PivotPointAttendanceListRequest
    ): Promise<PivotPointPaginatedResponse<PivotPointAttendance>> {
        const response = await this.post("/v1/integrations/pivot-point/attendance/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async getGradeSourcePayload(
        params: PivotPointGetGradeSourcePayloadRequest
    ): Promise<PivotPointGetGradeSourcePayloadResponse> {
        const response = await this.post("/v1/integrations/pivot-point/grades/source-payload", params)
        return get(response, "data", {success: false, data: {gradeId: params.gradeId, payload: {}}})
    }

    async updateGrade(params: PivotPointUpdateGradeRequest): Promise<PivotPointUpdateGradeResponse> {
        const response = await this.post("/v1/integrations/pivot-point/grades/update", params)
        return get(response, "data", {success: false, data: {id: params.gradeId}})
    }
}

export default PivotPointIntegrationService
